// extracted by mini-css-extract-plugin
export default {"primaryColor":"#fff","secondaryColor":"#161314","complementaryColor":"#b33862","aux":"#f06449","auxNeutral":"#eaeff3","free":"#d4edbc","reserved":"#ffe5a0","sold":"#ffcfc9"};